import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './RateLimitPage.css';

const RateLimitPage: React.FC = () => {
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(30);
  const [coffeeProgress, setCoffeeProgress] = useState(0);

  // Countdown timer
  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    } else {
      // Auto redirect when countdown reaches 0
      navigate('/basket-combination');
    }
  }, [countdown, navigate]);

  // Coffee fill animation
  useEffect(() => {
    const fillTimer = setInterval(() => {
      setCoffeeProgress(prev => {
        if (prev >= 100) return 0;
        return prev + 2;
      });
    }, 100);
    return () => clearInterval(fillTimer);
  }, []);

  const handleRetry = () => {
    navigate('/basket-combination');
  };

  return (
    <div className="rate-limit-container">
      <div className="rate-limit-content">
        {/* Animated Coffee Cup */}
        <div className="coffee-animation">
          <div className="coffee-cup">
            <div className="coffee-steam">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <div className="cup-body">
              <div 
                className="coffee-fill" 
                style={{ height: `${coffeeProgress}%` }}
              ></div>
            </div>
            <div className="cup-handle"></div>
          </div>
        </div>

        {/* Message */}
        <h1 className="rate-limit-title">
          Bir Nefes Alalım ☕
        </h1>
        
        <p className="rate-limit-message">
          AI stilistimiz şu anda çok meşgul!<br />
          Çok fazla istek aldık, biraz bekleyip tekrar deneyelim.
        </p>

        {/* Fun fact */}
        <div className="fun-fact">
          <span className="fun-fact-icon">💡</span>
          <p>Biliyor muydunuz? En iyi kombinler sabırlı bekleyenler içindir!</p>
        </div>

        {/* Countdown */}
        <div className="countdown-section">
          <div className="countdown-circle">
            <svg viewBox="0 0 100 100">
              <circle
                className="countdown-bg"
                cx="50"
                cy="50"
                r="45"
              />
              <circle
                className="countdown-progress"
                cx="50"
                cy="50"
                r="45"
                style={{
                  strokeDasharray: `${(countdown / 30) * 283} 283`
                }}
              />
            </svg>
            <span className="countdown-number">{countdown}</span>
          </div>
          <p className="countdown-text">saniye sonra otomatik yönlendirileceksiniz</p>
        </div>

        {/* Retry Button */}
        <button className="retry-button" onClick={handleRetry}>
          <span className="button-icon">🔄</span>
          Şimdi Tekrar Dene
        </button>

        {/* Decorative elements */}
        <div className="floating-emojis">
          <span className="emoji emoji-1">👗</span>
          <span className="emoji emoji-2">👔</span>
          <span className="emoji emoji-3">👠</span>
          <span className="emoji emoji-4">🎀</span>
          <span className="emoji emoji-5">✨</span>
        </div>
      </div>
    </div>
  );
};

export default RateLimitPage;

